import { useContext } from 'react';

import { IsPDFContext } from './IsPDFContext.js';

export function useIsPDF(): boolean {
  return useContext(IsPDFContext);
}
